import { render, staticRenderFns } from "./AIVDialog.vue?vue&type=template&id=0ef9e33a"
import script from "./AIVDialog.vue?vue&type=script&lang=js"
export * from "./AIVDialog.vue?vue&type=script&lang=js"
import style0 from "./AIVDialog.vue?vue&type=style&index=0&id=0ef9e33a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports